import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-menu\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" opacity=\".01\" /><path fill=\"currentColor\" fill-opacity=\".7\" fill-rule=\"evenodd\" d=\"M14 2.5v1H2v-1zm0 5v1H2v-1zm0 6v-1H2v1z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol